import { IconArrowsArrangeSort } from '@doltech/icons-from-dev/IconArrowsArrangeSort';
import { IconArrowsCheck } from '@doltech/icons/IconArrowsCheck';
import { IconContentFilter } from '@doltech/icons/IconContentFilter';
import { Dropdown, Menu } from 'antd';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import React from 'react';
import styled from 'styled-components';

import { Button } from '../ButtonV2/ButtonV2';
import { colorsV2 } from '../colors-v2';
import { Typography } from '../DesignSystemV2/Typography';
import { shadows } from '../shadows';
import { useFilterMobileStore, useFilterStore } from './useStore';

export const Trigger = observer((props) => {
  const { setOpen, sync } = useFilterMobileStore();
  const filterStore = useFilterStore();

  return (
    <Button
      count={`${filterStore.selectedCount || ''}`}
      type="secondary"
      variant="outline"
      size="large"
      onClick={() => {
        sync(getSnapshot(filterStore));
        setOpen();
      }}
      iconLeft={<IconContentFilter />}
    >
      <Typography.Text variant="semi-bold/16">Bộ lọc</Typography.Text>
    </Button>
  );
});

const MenuMain = styled(Menu)`
  box-shadow: ${shadows.zIndex4};
  border-radius: 8px;
`;

const MenuItem = styled(Menu.Item)`
  min-width: 216px;
  min-height: 40px;
  color: ${colorsV2.black100};
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 16px;
  .ant-menu-title-content {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    align-items: center;
    gap: 8px;
    .icon {
      transition: opacity 0.3s ease;
      opacity: 0;
      font-size: 24px;
      line-height: 0;
      color: ${colorsV2.black100};
    }
  }
  .ant-dropdown-menu-item-icon {
    opacity: 0;
  }
  &.ant-menu-item-selected &.active,
  &:hover {
    background: ${colorsV2.blue10};
    color: ${colorsV2.black100} !important;
  }

  &.active {
    .ant-dropdown-menu-item-icon {
      opacity: 1;
    }
    .ant-menu-title-content .icon {
      opacity: 1;
    }
  }
`;

const DEFAULT_SORT_VALUE = 'ordering,asc';

const SortMenu = observer(() => {
  const filterStore = useFilterStore();
  const { sync } = useFilterMobileStore();

  const sortGroup = React.useMemo(() => {
    return filterStore.groups.find((group) => group.queryKey === 'sort');
  }, [filterStore.groups]);
  const sortOptions = sortGroup.options.filter((option) => !option.hidden);

  return (
    <MenuMain
      onClick={(info) => {
        const { key } = info;
        if (sortGroup.selectedValue === key) {
          sortGroup.setSelectedValue(DEFAULT_SORT_VALUE);
        } else {
          sortGroup.setSelectedValue(key);
        }
        filterStore.update({
          page: 1,
        });
        sync(getSnapshot(filterStore));

        filterStore.setSortMenuVisible(false);
      }}
    >
      {sortOptions.map((option) => {
        const { label, value } = option;
        return (
          <MenuItem className={cl({ active: sortGroup.selectedValue === value })} key={value}>
            <div className="text">{label}</div>
            <div className="icon">
              <IconArrowsCheck />
            </div>
          </MenuItem>
        );
      })}
    </MenuMain>
  );
});

export const SortButton = observer(() => {
  const filterStore = useFilterStore();
  const getSortLabel = () => {
    const sortGroup = filterStore.groups.find((group) => group.queryKey === 'sort');
    const currentSortOption = sortGroup.options.find(
      (option) => option.value === sortGroup.selectedValue
    );

    if (currentSortOption?.label && currentSortOption?.label !== 'ordering') {
      return currentSortOption.label;
    }
    return 'Sắp xếp';
  };
  return (
    <Dropdown open={filterStore.sortMenuVisible} trigger={['click']} overlay={<SortMenu />}>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          filterStore.setSortMenuVisible(!filterStore.sortMenuVisible);
        }}
        type="secondary"
        variant="outline"
        size="large"
        iconLeft={<IconArrowsArrangeSort />}
      >
        <Typography.Text variant="semi-bold/16">{getSortLabel()}</Typography.Text>
      </Button>
    </Dropdown>
  );
});
